import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { GridActionButtonComponent } from '../grid-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export const ActionButtonComponent = (props: GridActionButtonComponent) => {
  const classes = useStyles();
  const { label, onClick } = props;

  return (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.actionButton}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
